import { ApplicationRef, Component, inject, ViewChild } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { Config } from 'src/modules/app-template/models/config.model';
import { EnaioAssignment } from 'src/modules/enaio/shared/EnaioAssignment';
import { EnaioCallCompleteWorkItem } from 'src/modules/enaio/shared/EnaioCallCompleteWorkItem';
import { EnaioCallInsert } from 'src/modules/enaio/shared/EnaioCallInsert';
import { EnaioDocument } from 'src/modules/enaio/shared/EnaioDocument';
import { EnaioLocation } from 'src/modules/enaio/shared/EnaioLocation';
import { EnaioObjectId } from 'src/modules/enaio/shared/EnaioObjectId';
import { EnaioObjectType } from 'src/modules/enaio/shared/EnaioObjectType';
import { EnaioObjectTypeId } from 'src/modules/enaio/shared/EnaioObjectTypeId';
import { EnaioProcess } from 'src/modules/enaio/shared/EnaioProcess';
import { EnaioUpsertResult } from 'src/modules/enaio/shared/EnaioUpsertResult';
import { EnaioUserIdentification } from 'src/modules/enaio/shared/EnaioUserIdentification';
import { EnaioWorkflowDefinition } from 'src/modules/enaio/shared/EnaioWorkflowDefinition';
import { EnaioWorkflowDocument } from 'src/modules/enaio/shared/EnaioWorkflowDocument';
import { SmTable2Component } from 'src/modules/sm-base/components/sm-table2/sm-table2.component';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { BrowserUploadedFile } from 'src/modules/sm-base/models/uploaded-file.model';
import { FileUploadService } from 'src/modules/sm-base/services/file-upload-service';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { FrontendEnaioMapper } from '../../../enaio/models/frontend-enaio-mapper.model';
import { EnaioWorkflowsConfig } from '../../enaio-workflows.config';
import { EnaioWorkItemDto } from '../../models/enaio-work-item-dto.model';
import { FrontendWorkflowActivityDefinition } from '../../models/frontend-workflow-activity-definition.model';
import { FrontendWorkflowDefinition } from '../../models/frontend-workflow-definition.model';
import { WorkflowForm } from '../../models/workflow-form.model';
import { EnaioDocumentResult } from 'src/modules/enaio-documents/models/enaio-document-result.model';

@Component({
    selector: 'enaio-work-item',
    templateUrl: './enaio-work-item.component.html',
    styleUrls: []
})
export class EnaioWorkItemComponent extends ComponentView {

    _Utils = Utils;

    applicationRef = inject(ApplicationRef);
    fileUpload = inject(FileUploadService);

    neededParams: ObjectOfSimpleDataTypes = { processId: "string" };
    processId = "";

    loading = true;
    isForwarding = false;
    formWidth = 0;
    formHeight = 0;
    workItem: EnaioWorkItemDto;
    process: EnaioProcess;
    workflowModel: EnaioWorkflowDefinition;
    workflowDef: FrontendWorkflowDefinition;
    workflowActivityDef: FrontendWorkflowActivityDefinition;
    workflowForm: WorkflowForm = null;
    selectedDocument: EnaioDocumentResult;
    canAddDocuments: boolean;
    documentsTable: TableData;
    documentIdsAtOpen: number[] = [];
    debugViewString = "";
    fd = Config.get().getModuleConfig(EnaioWorkflowsConfig).fd;

    @ViewChild("documentsTableComponent") documentsTableComponent: SmTable2Component;
    
    async initParams(): Promise<boolean> {
        try {
            this.workItem = await this.app.loadDataHandler(async () => await RestEndpoint.main().query({ processId: this.processId }).run("api/wfl/workflow/workitem").get(EnaioWorkItemDto), this);
        }
        catch (ex) {
            return false;
        }
        this.documentIdsAtOpen = this.workItem.documents.map(doc => doc.doc.id);
        this.process = await RestEndpoint.main().query({ processId: this.workItem.workItem.processId}).run("api/wfl/workflow/process").get(EnaioProcess);
        this.workflowModel = await RestEndpoint.main().query({ familyId: this.process.model.familyId, modelId: this.process.model.id }).run("api/wfl/workflow/workflowDefinition").get(EnaioWorkflowDefinition);
        this.workflowDef = (await RestEndpoint.main().run("api/wfl/workflow/definitions").list(FrontendWorkflowDefinition)).find(fwd => fwd.familyName == this.workflowModel.familyPackage.name) ?? new FrontendWorkflowDefinition();
        this.workflowActivityDef = this.workflowDef.getActivity(this.workItem.workItem.activityName);
        //this.canAddDocuments = this.workflowDef.showTray && (this.workflowDef.allowedAttachmentObjectTypes == null || this.workflowDef.allowedAttachmentObjectTypes.length > 0);
        this.canAddDocuments = this.workflowDef.showTray && this.workflowDef.allowedAttachmentObjectTypes?.length == 1;

        this.workflowForm = new WorkflowForm(this.workItem.workItem, this.workflowModel, this.app.getUserName(), this.app, this.fileUpload, this.applicationRef);
        this.formWidth = this.workItem.workItem.masks[0].width * FrontendEnaioMapper.scaleFactor;
        this.formHeight = this.workItem.workItem.masks[0].height * FrontendEnaioMapper.scaleFactor;

        await this.workflowForm.init();

        this.updateDocumentsTable();
        //Funktioniert nicht GuiUtils.angularTimer(() => this.documentsTableComponent.selectFirstRow());
        
        this.app.updateNavigation(this.app.t("wfs.workflow") + " - " + this.workflowForm.workItem.processName, [
            { label: this.workflowForm.workItem.processName, routerLink: ["/enaio-workflows/workitem", this.workflowForm.workItem.id] }
        ]);
        this.refreshDebugView();
        this.loading = false;
        return true;
    }

    refreshDebugView(): void {
        this.debugViewString = Utils.replaceAll(Utils.toJson(this.workflowForm.workItem.getParameterObject(), true) + '\n\n\n' + Utils.toJson(this.workflowForm.workItem.masks[0].fields, true), '\n', '<br>');
    }

    async runScript(id: string): Promise<void> {
        this.workflowForm.runScriptByName(id);
    }

    async forward(): Promise<void> {
        this.isForwarding = true;
        if (await this.workflowForm.forward()) {
            await this.app.navigateTo(["/enaio-workflows", "home"]);
        }
        else {
            this.isForwarding = false;
        }
    }

    async forwardSimulate(): Promise<void> {
        await this.workflowForm.forward(true);
    }

    async save(): Promise<void> {
        this.isForwarding = true;
        if (await this.workflowForm.save()) {
            await this.app.navigateTo(["/enaio-workflows", "home"]);
        }
        else {
            this.isForwarding = false;
        }
    }

    async cancel(): Promise<void> {
        if (await this.app.messageDialog.yesNo(this.app.t("general.cancelMessage"), this.app.t("general.cancel"))) {
            this.isForwarding = true;
           // await RestEndpoint.main().post().query({ processId: this.processId }).run("api/wfl/workflow/workItemCancel").getString();
            await this.app.navigateTo(["/enaio-workflows", "home"]);
        }
    }

    updateDocumentsTable(): void {
        if (this.fd) {
            //PRAGMATIC (zukünftig konfigurierbar)
            this.documentsTable = new TableData([
                new TableColumn("Typ", this.app.t("objectDef.Reisekostenbeleg.Typ"), TableCellType.text, { autoWidth: 30 }), 
                new TableColumn("Bemerkung", this.app.t("objectDef.Reisekostenbeleg.Bemerkung"), TableCellType.text, { flex: 1 })
            ], this.workItem.documents.map(file => new TableRow("", file, {
                Typ: file.doc.getStringByInternal("Typ"),
                Bemerkung: file.doc.getStringByInternal("Bemerkung")
            }, { canDeleteInternal: !this.documentIdsAtOpen.includes(file.doc.id) })), [new TableSortColumn("Typ")]);
        }
        else {
            this.documentsTable = new TableData([
                new TableColumn("Typ", "Typ", TableCellType.text, { autoWidth: 30 }), 
            ], this.workItem.documents.map(file => new TableRow("", file, {
                Typ: "Dokument",
            }, { canDeleteInternal: false })), [new TableSortColumn("Typ")]);
        }        
    }

    _removeDocument = this.removeDocument.bind(this);

    async removeDocument(row: TableRow, rowIndex: number): Promise<void> {
        let call = Utils.fromPlain(EnaioCallCompleteWorkItem, {
            user: EnaioUserIdentification.byUserName(this.app.getUserName()),
            workItemId: this.workItem.workItem.id,
            send: false,
            deleteDocumentIds: [(row.raw as EnaioDocumentResult).doc.id]
        });
        await RestEndpoint.main().post().body(call).run("api/wfl/workflow/workitem").getText();
        
        let workItem = await RestEndpoint.main().query({ processId: this.processId }).run("api/wfl/workflow/workitem").get(EnaioWorkItemDto);
        this.workItem.workItem.files = workItem.workItem.files;
        this.workItem.documents = workItem.documents;

        this.updateDocumentsTable();
    }

    async attachDocument(): Promise<void> {
        let ot: EnaioObjectTypeId = null;
        if (this.workflowDef.allowedAttachmentObjectTypes?.length == 1) {
            ot = this.workflowDef.allowedAttachmentObjectTypes[0];
        }
        else {
            //let all = this.workflowDef.allowedAttachmentObjectTypes ?? [];
            throw new Error("Nicht implementiert - TODO");
        }

        let otd = await RestEndpoint.main().body(ot).post().run("api/wfl/dms/objectTypeDefinition").get(EnaioObjectType);

        //PRAGMATIC (zukünftig konfigurierbar)
        let fields = otd.getAllFields().filter(f => f.name != "Personalnr" && f.name != "Name" && f.name != "Vorname");
        let form = FrontendEnaioMapper.enaioToFrontendForm(fields, this.app, "objectDef." + otd.internalName, [], true, true);
        form.fields.push(new FrontendFieldDefinition("document", this.app.t("general.document"), FrontendFieldType.fileUpload, { mandatory: true }));

        if (await this.app.messageDialog.form(form, this.app.t("enaio.indexData")) == "ok") {
           // let wfParams = this.workflowForm.workItem.getParameterObject();
            let callInsert = Utils.fromPlain(EnaioCallInsert, {
                archive: ot.archive,
                objectType: ot.objectType,
                location: new EnaioLocation(null, this.app.auth.userDetails.getDatabaseUser().getAttributeValueNumber("folderId")),
                fields: [
                    ...fields.map(f => new EnaioAssignment(EnaioObjectId.byInternalName(f.internalName), Utils.stringDef(form.getValue(f.internalName) as string)))/*,
                    new EnaioAssignment(EnaioObjectId.byName("Personalnr"), wfParams.personellNumber),
                    new EnaioAssignment(EnaioObjectId.byName("Name"), wfParams.lastname),
                    new EnaioAssignment(EnaioObjectId.byName("Vorname"), wfParams.firstname)*/
                ],
                documentBase64: Utils.bytesToBase64((form.getValue("document") as BrowserUploadedFile[])[0].contents),
                documentFileName: (form.getValue("document") as BrowserUploadedFile[])[0].legacy.name
            });

            let upsertResult = await RestEndpoint.main().post().body(callInsert).run("api/wfl/tbr/insert").get(EnaioUpsertResult);

            let call = Utils.fromPlain(EnaioCallCompleteWorkItem, {
                user: EnaioUserIdentification.byUserName(this.app.getUserName()),
                workItemId: this.workItem.workItem.id,
                send: false,
                documents: [Utils.fromPlain(EnaioWorkflowDocument, {
                    id: upsertResult.documentId,
                    objectTypeId: otd.Id,
                    isNew: true
                })]
            });
            await RestEndpoint.main().post().body(call).run("api/wfl/workflow/workitem").getText();

            let workItem = await RestEndpoint.main().query({ processId: this.processId }).run("api/wfl/workflow/workitem").get(EnaioWorkItemDto);
            this.workItem.workItem.files = workItem.workItem.files;
            this.workItem.documents = workItem.documents;

            this.updateDocumentsTable();
        }
    }

    selectDocument(event: any): void {
        let doc = event.raw as EnaioDocumentResult;
        this.selectedDocument = doc;
    }

}
